export enum MilesCreditApplicationStipulationStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  CREATED = 'CREATED',
  RECEIVED = 'RECEIVED',
  REFUSED = 'REFUSED',
}

export enum MilesStipulationTypeDefinitionId {
  ID_CARD_APPLICANT = '400014',
  ID_CARD_SIGNATORY = '400141',
}

export interface DocumentItem {
  documentId: string;
  description: string;
}

export interface StipulationItem {
  id: string;
  status: MilesCreditApplicationStipulationStatus;
  name: string;
  stipulationTypeTranslation: string;
  stipulationTypeDefinitionId?: string;
  isMandatory: boolean;
  canUpload: boolean;
  canDelete: boolean;
  documents: Array<DocumentItem>;
}

export interface GetStipulationDocumentsResponse {
  stipulations: Array<StipulationItem>;
  coApplicantStipulations?: Array<StipulationItem>;
  creditApplicationCoApplicantId?: string;
}
